// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles-module--highlight--12QiN","feminine":"styles-module--feminine--3Zxyi","masculine":"styles-module--masculine--2Vie4","bold":"styles-module--bold--35YJV"};